import { render, staticRenderFns } from "./month-bill.vue?vue&type=template&id=5bea3e71&"
import script from "./month-bill.vue?vue&type=script&lang=js&"
export * from "./month-bill.vue?vue&type=script&lang=js&"
import style0 from "./month-bill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports